/* eslint-disable eag/match-named-export */
import {Nullish} from 'shared/web';

export type Option<T = string> = {
  label: string;
  value: T;
};

export type OptionWithProperties<T = string, P = string> = {
  label: string;
  value: T;
  properties: Option<P>[] | Nullish;
};

export type VehicleCatalogueReturnType = [
  {
    getVehicleType: (carStyle: string | Nullish) => string | Nullish;
    getBodyStyle: (bodyStyle: string | Nullish) => string | Nullish;
    getFuelType: (fuelType: string | Nullish) => string | Nullish;
    getHybridType: (hybridType: string | Nullish) => string | Nullish;
    getBatteryType: (batteryType: string | Nullish) => string | Nullish;
    getChargingConnectorType: (chargingConnectorType: string | Nullish) => string | Nullish;
    getBatteryOwnershipType: (batteryOwnershipType: string | Nullish) => string | Nullish;
    getDrive: (drive: string | Nullish) => string | Nullish;
    getFeature: (feature: string | Nullish) => string | Nullish;
    getTransmission: (transmission: string | Nullish) => string | Nullish;
    getColorType: (colorType: string | Nullish) => string | Nullish;
    getBodyColor: (bodyColor: string | Nullish) => string | Nullish;
    getBodyColorHEX: (bodyColor: string | Nullish) => string | Nullish;
    getInteriorMaterial: (interiorMaterial: string | Nullish) => string | Nullish;
    getEmissionClass: (emissionClass: string | Nullish) => string | Nullish;
    getDoorCount: (doorCount: string | Nullish) => string | Nullish;
    getHandDrive: (handDriveType: string | Nullish) => string | Nullish;
    handDriveOptions: Option[] | Nullish;
    driveOptions: Option[] | Nullish;
    fuelTypeOptions: OptionWithProperties[] | Nullish;
    hybridTypeOptions: Option[] | Nullish;
    batteryTypeOptions: Option[] | Nullish;
    batteryOwnershipTypeOptions: Option[] | Nullish;
    chargingConnectorTypeOptions: Option[] | Nullish;
    vehicleStyleOptions: Option[] | Nullish;
    transmissionOptions: Option[] | Nullish;
    featureOptions: Option[] | Nullish;
    bodyColorTypeOptions: Option[] | Nullish;
    bodyColorOptions: Option[] | Nullish;
    doorCountOptions: Option[] | Nullish;
    seatCountOptions: Option[] | Nullish;
    interiorColorOptions: Option[] | Nullish;
    fullDoorCountOptions: Option[] | Nullish;
    interiorMaterialOptions: Option[] | Nullish;
    vehicleTypeOptions: Option[] | Nullish;
    serviceBookStateOptions: Option[] | Nullish;
    serviceBookTypeOptions: Option[] | Nullish;
    vehicleConditionOptions: Option[] | Nullish;
    emissionClassOptions: Option[] | Nullish;
    dimensionsHeightOptions: Option[] | Nullish;
    dimensionsLengthOptions: Option[] | Nullish;
  },
  {
    isError: boolean;
    isLoading: boolean;
  },
];

export type VehicleCatalogueData = {
  keys: Key[];
  property_name?: string;
  vehicle_type?: string | null;
}[];

export type Key = {
  categories: string[];
  const_key: string;
  const_key_old: string | null;
  labels: Label[];
  parent?: string | null;
  properties?: Property[];
  sort_priority?: number | null;
};

type Label = {
  label: string;
  label_short: string | null;
  language?: string | null;
  seo_label?: string | null;
};

type Property = {
  name: string;
  value?: any; // eslint-disable-line typescript/no-explicit-any -- Pre-existing any
} | null;
